import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FieldBase } from '@nagel-types';

const WITH_ACTIONS = 'with-actions';
const WITHOUT_ACTIONS = 'without-actions';
const DATEPICKER_VARIANTS = [WITH_ACTIONS, WITHOUT_ACTIONS];

export class DatePickerErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null): boolean {
        if (!(control?.errors))
        {
            return false;
        }

        return control!.errors && control!.errors['matDatepickerParse'].text !== '';
    }
}

@Component({
    selector: 'lib-date-picker',
    imports: [
        FormsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatInputModule,
        MatInputModule
    ],
    templateUrl: './date-picker.component.html',
    styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent extends BaseFieldComponent {
    @Input() override field!: FieldBase<unknown>;
    @Input() override form!: FormGroup;
    @Input() matcher: ErrorStateMatcher = new DatePickerErrorStateMatcher();

    @Input() key: string = '';
    @Input() value: Date | null = null;
    @Input() label: string = '';
    @Input() readonly: boolean = false;
    @Input() disabled: boolean = false;
    @Input() variant: string = '';

    ngOnInit() {
        this.key = this.field?.key ?? this.key;
        this.value = this.field?.value as Date | null ?? this.value;
        this.label = this.field?.label ?? this.label;
        this.readonly = this.field?.readonly ?? this.readonly;
        this.disabled = this.field?.disabled ?? this.disabled;
        this.variant = this.field?.variant ?? this.variant;
    }

    ngOnChanges() {
        this.value = this.value as Date | null ?? null;
    }

    isDatePickerDisabled() {
        return this.readonly || this.form.get(this.key)?.disabled;
    }

    shouldShowActions = () => {
        return this.variant
            ? DATEPICKER_VARIANTS.includes(this.variant || '') && this.variant === WITH_ACTIONS
            : true;
    };
}